import React, {useState} from 'react';
import Layout from './layout';
import ContractAdd from './contract-add';
import ContractView from './contract-view';
import StatusView from './status-view';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function Contract(): React.ReactElement {
    const urlParams = new URLSearchParams(window.location.search);
    const collectionId = String(urlParams.get('collectionId'));
    const addNew = String(urlParams.get('action'));
    const [statusMessage, setStatusMessage] = useState({message: '', type: StatusMessageTypeEnum.none});

    const onStatusMessage = (message: string, type: StatusMessageTypeEnum) => {
        setStatusMessage({message, type});
    };

    let view = <div/>;
    if (addNew === 'add') {
        view = (
            <>
                <div className="banner"/>
                <ContractAdd collectionId={collectionId} setStatusMessage={onStatusMessage}/>
            </>
        );
    } else {
        view = (
            <div className="pt-3">
                <ContractView setStatusMessage={onStatusMessage}/>
            </div>
        );
    }

    return (
        <Layout className="page home ">
            <StatusView status={statusMessage}/>
            {view}
            <div/>
        </Layout>
    );
}

export default Contract;
